export const TEXT_STATUS = {
	open: 'Antes de cerrar una solicitud del tipo "Reclamo", elige una respuesta automática o escribe un comentario personalizado.',
	close: 'La solicitud fue cerrada con éxito.',
};
